// eslint-disable-next-line no-unused-vars
import React, { memo, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useContextSelector } from 'use-context-selector';
import { Global, css } from '@emotion/react';

import Checkout from 'Containers/Checkout/Checkout';
import { UserContext } from 'Contexts/UserContext';
import useRouter from 'Hooks/useRouter';
import OrderProvider from 'Contexts/OrderContext';
import CreateWishlistModal from 'Containers/Wishlists/CreateWishlistModal';

const CheckoutPage = memo(() => {
  const { t } = useTranslation();
  const { replace } = useRouter();
  const { bodyAttributes } = Helmet.peek() || {};
  const email = useContextSelector(UserContext, ({ data }) => data?.email);

  useEffect(() => {
    if (!email) {
      replace('/login');
    }
  }, [email]);

  let checkoutPageClassNames = bodyAttributes?.class || '';
  if (!checkoutPageClassNames.includes('CheckoutPage')) {
    checkoutPageClassNames += 'CheckoutPage';
  }

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <title>{ t('common.pages.checkout') }</title>
        <body className={ checkoutPageClassNames } />
      </Helmet>
      <Global
        styles={
          css`
            .CheckoutPage {
              .MainNavigation,
              .BreadCrumbs {
                display: none;
              }
            }
          `
        }
      />
      <CreateWishlistModal />
      <OrderProvider>
        <Checkout />
      </OrderProvider>
    </>
  );
});
CheckoutPage.displayName = 'CheckoutPage';

export default CheckoutPage;
